import { useQuery } from "@tanstack/react-query";
import { getSession, getSessionId, updateSession } from "../api/session";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useAuth, useUser } from "@clerk/clerk-react";

export const useSession = () => {
  const sessionId = useSessionId();
  const { isSignedIn, user, isLoaded } = useUser();
  const { getToken } = useAuth();

  const { data: session, isLoading } = useQuery({
    queryKey: ["session"],
    queryFn: () => getSession({ sessionId, getToken }),
    enabled: !!user && !!sessionId,
  });

  return session;
};

export type UpdateSessionInput = {
  facts: string;
  sessionId: string;
};

export type UpdateSessionResponse = {
  content?: string | null;
  description?: string | null;
  statusCode?: number;
};

export const useUpdateSession = (
  options?: UseMutationOptions<UpdateSessionResponse, unknown, UpdateSessionInput, unknown>
) => {
  const { onSuccess, ...restOptions } = options ?? {};
  const { getToken } = useAuth();
  return useMutation({
    mutationFn: async (input) =>
      updateSession({
        sessionId: input.sessionId,
        body: {
          facts: input.facts,
        },
        getToken,
      }),
    onSuccess(...args) {
      onSuccess?.(...args);
    },
    onError: (error, variables) => {
      console.error("useUpdateSession error", error, variables);
    },
    ...restOptions,
  });
};

export const useSessionId = () => {
  const { getToken } = useAuth();

  const { data: sessionId, isLoading } = useQuery({
    queryKey: ["sessionId"],
    queryFn: () => getSessionId({ getToken }),
  });

  return sessionId;
};
